export class Sonde {
    Code: string;
    SondePh: string;
    SondeConductivite: string;
    SondeOxygene: string;
    Appareil: string;

    static mapFromJSON(json: any): Sonde {
        const s = new Sonde();

        s.Code = json.code;
        s.SondePh = json.sondePh;
        s.SondeConductivite = json.sondeConductivite;
        s.SondeOxygene = json.sondeOxygene;
        s.Appareil = json.appareil;
        return s;
    }
}